export const THIS_FIELD_IS_REQUIRED = 'This field is required';
export const THIS_VALUE_IS_TOO_HIGH = 'This value is too high and may cause performance issues';
export const THIS_VALUE_IS_TOO_LOW = 'This value is too low and might compromise path profiling';
